<template>
  <div>
    <right-panel :datas="connects" @onClose="onCloseForm" ref="right-panel">
      <div slot="header">
        <translate>Scan Import</translate>
      </div>
      <div slot="content" class="wrapper-padding">
        <el-form :model="scanForm" :rules="rules" ref="scanForm" label-width="120px" class="demo-ruleForm"
                 v-show="!newQueryShow">
          <el-form-item :label="attrText.cidrBlock" prop="cidr" class="fixed-text">
            <el-input v-model="scanForm.cidr" :placeholder="attrText.network"></el-input>
          </el-form-item>
          <el-form-item :label="attrText.os" prop="os" class="select-role">
            <el-select v-model="scanForm.os" @change="changeOs">
              <el-option label="Windows" value="win32"></el-option>
              <el-option label="Linux" value="linux"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="attrText.port" prop="port">
            <el-input v-model="scanForm.port"></el-input>
          </el-form-item>
          <el-form-item :label="attrText.userName" prop="userName">
            <el-input v-model="scanForm.userName"></el-input>
            <translate>Multiple users with semicolons ‘;’</translate>
          </el-form-item>
        </el-form>
        <!--开始轮询-->
        <div class="scan-import" v-show="newQueryShow">
          <div class="scan-process">
            <div class="process" v-if="agentVersion && agentVersion < '3.0.0'">
              <el-progress :percentage="processPercent" :stroke-width="20" :show-text="false"></el-progress>
            </div>
            <div class="scan-btn">
              <div class="hide_duplicate_switch">
                <translate>Hide the same resources as the IP in the cluster</translate>
                <el-switch on-text="" off-text="" v-model="queryScan.hide_duplicate_ip" :disabled="!queryScan.isCanRestart" @change="changeHideDuplicateIp"></el-switch>
              </div>
              <el-button @click="onScanAgain()" :disabled="!queryScan.isCanRestart" class="scan_again">
                <translate>Scan again</translate>
              </el-button>
            </div>
          </div>
          <div class="scan-table" v-if="agentVersion && agentVersion < '3.0.0'">
            <el-table :data="queryScan.list" style="width: 100%" :row-class-name="tableRowClassName"
                      @selection-change="onSelectImport">
              <el-table-column type="selection" width="30"></el-table-column>
              <el-table-column label="IP" prop="ip"></el-table-column>
              <el-table-column :label="attrText.port" prop="port"></el-table-column>
            </el-table>
          </div>
          <div class="scan-table" v-if="agentVersion && agentVersion >= '3.0.0'">
            <el-table :data="queryScan.list" style="width: 100%" :row-class-name="tableRowClassName"
                      @selection-change="onSelectImport" v-loading="!queryScan.list">
              <el-table-column type="selection" width="30"></el-table-column>
              <el-table-column label="IP" prop="ip"></el-table-column>
              <el-table-column :label="attrText.port" prop="port"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div slot="footer" class="detail-btn" v-if="queryScan.total === 1">
          <el-button type="primary" :disabled="!queryScan.isCanScan" @click="onStartScan()" v-loading="scanLoading">
            <translate>Scan</translate>
          </el-button>
          <el-button @click="$refs['right-panel'].onClose()">
            <translate>Cancel</translate>
          </el-button>
        </div>
        <!-- newQueryShow task_id拿到该值即为true -->
        <div slot="footer" class="detail-btn" v-if="newQueryShow">
          <el-button type="primary" @click="onStartImport()"
                     :disabled="!queryScan.isCanImport || queryScan.importLoading" v-loading="queryScan.importLoading">
            <translate>Import</translate>
          </el-button>
          <el-button @click="onCloseForm()">
            <translate>Cancel</translate>
          </el-button>
        </div>
      </div>
    </right-panel>
  </div>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  import Utilty from '../../../Utils'
  export default{
    name: 'ClusterScanImport',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null,
        agentVersion: null,
        scanForm: {
          cidr: '',
          os: 'linux',
          port: '22',
          userName: 'root'
        },
        queryScan: {
          taskId: '',
          process: 0,
          list: null,
          total: 1,
          selectList: [],
          isCanImport: false,
          isCanScan: false,
          isCanRestart: false,
          importLoading: false,
          hide_duplicate_ip: false
        },
        nameOsObj: {
          'win32': 'administrator',
          'linux': 'root'
        },
        queryTimeout: null,
        newQueryShow: false,
        scanLoading: false,
        rules: {
          cidr: [
            {required: true, message: this.$gettext('Please input the Cidr Block'), trigger: 'blur'},
            {
              pattern: /^((\d|([1-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\.)(([0-9]|([1-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\.){2}([0-9]|([1-9]\d)|(1\d\d)|(2([0-4]\d|5[0-5])))\/(2[4-9]|3[0-2])$/,
              message: this.$gettext('e.g. 10.0.0.0/24, and only supports 24-32'),
              trigger: 'change,blur'
            }
          ],
          os: [
            {required: true, message: this.$gettext('Please select the os'), trigger: 'change'}
          ],
          port: [
            {required: true, message: this.$gettext('Please input the port'), trigger: 'change'},
            {
              pattern: /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
              message: this.$gettext('please input the right port'),
              trigger: 'change'
            }
          ],
          userName: [
            {required: true, message: this.$gettext('Please input the userName'), trigger: 'change'}
          ]
        }
      }
    },
    created () {
//      console.log('dc', Object.assign({}, this.scanForm, {os: 'linux'}))
    },
    computed: {
      attrText () {
        return this.getTransitionText()
      },
      // 进度条
      processPercent () {
        return Math.floor(this.queryScan.process / this.queryScan.total * 100)
      }
    },
    methods: {
      getTransitionText () {
        return {
          cidrBlock: this.$gettext('Cidr Block'),
          os: this.$gettext('OS'),
          port: this.$gettext('Port'),
          network: this.$gettext('Network, e.g. 10.0.0.0/24'),
          userName: this.$gettext('userName'),
          moreUser: this.$gettext('Multiple users with semicolons ‘;’')
        }
      },
      // 切换操作系统更换默认用户名
      changeOs (val) {
        if (val === 'linux') {
          this.scanForm.port = '22'
        } else {
          this.scanForm.port = '3389'
        }
        this.scanForm.userName = this.nameOsObj[val]
      },
      // 确定扫描
      onStartScan () {
        console.log('this.scanForm.userName', this.scanForm.userName)
        this.scanLoading = true
        let params = {
          cidr: this.scanForm.cidr,
          network_id: this.$route.params.id,
          ports: this.scanForm.port,
          username: '',
          r: Math.random()
        }
        let arr = []
        this.scanForm.userName.split(';').forEach(el => {
          if (el && el.trim()) {
            arr.push(el.trim())
          }
        })
        params.username = arr.join(';')
        this.$store.dispatch(STORE_CONST.CLUSTER.SCAN_SATRT, params).then(res => {
          this.newQueryShow = true
          this.scanLoading = false
          this.queryScan.taskId = res.task_id
          this.onScanQuery()
        })
      },
      // 扫描轮询
      onScanQuery () {
        let params = {
          task_id: this.queryScan.taskId,
          network_id: this.$route.params.id,
          hide_duplicate: this.queryScan.hide_duplicate_ip ? '1' : '0'
        }
        if (Utilty.Utils.getAgentVersion(this.connects.agent.version) >= '3.0.0') {
          this.$store.dispatch(STORE_CONST.CLUSTER.SCAN_NEW_QUERY, params).then(res => {
            if (Object.keys(res).length > 0) {
              this.queryScan.isCanRestart = true
              this.queryScan.list = res.result
              clearTimeout(this.queryTimeout)
            } else {
            }
          }, (err) => {
            this.queryScan.isCanRestart = true
            this.queryScan.list = []
            if (Object.keys(err).length > 0) {
              this.$notify({
                type: 'warning',
                message: this.$gettext(err.error_message)
              })
            }
            clearTimeout(this.queryTimeout)
          })
          this.queryTimeout = setTimeout(this.onScanQuery, 3000)
        } else {
          if (this.queryScan.process < 0 || (this.queryScan.process > this.queryScan.total)) {
            this.queryScan.isCanRestart = true
            clearTimeout(this.queryTimeout)
          } else {
            this.$store.dispatch(STORE_CONST.CLUSTER.SCAN_QUERY, params).then(res => {
              this.queryScan.isCanRestart = true
              this.queryScan.process = res.process
              this.queryScan.list = res.result
              this.queryScan.total = res.total
            }, () => {
              this.queryScan.isCanRestart = true
              clearTimeout(this.queryTimeout)
            })
            this.queryTimeout = setTimeout(this.onScanQuery, 3000)
          }
        }
      },
      // 重新扫描
      onScanAgain () {
        this.queryScan.process = 0
        this.queryScan.total = 2
        this.queryScan.list = null
        this.queryScan.isCanRestart = false
        this.onStartScan()
      },
      // 切换隐藏重复IP
      changeHideDuplicateIp (val) {
        this.queryScan.hide_duplicate_ip = val
        this.onScanAgain()
      },
      // 选中要导入的
      onSelectImport (v) {
        console.log('v', v)
        this.queryScan.selectList = v
        if (v.length === 0) {
          this.queryScan.isCanImport = false
        } else {
          this.queryScan.isCanImport = true
        }
      },
      // 开始导入
      onStartImport () {
        let params = []
        this.queryScan.importLoading = true
        this.queryScan.selectList.forEach((item) => {
          let extension = {
            'os': this.scanForm.os,
            'username': ''
          }
          let arr = []
          this.scanForm.userName.split(';').forEach(el => {
            if (el && el.trim()) {
              arr.push(el.trim())
            }
          })
          extension.username = arr
          if (this.scanForm.os === 'linux') {
            extension.ssh_port = item.port
          } else {
            extension.rdp_port = item.port
          }
          params.push({
            extension: JSON.stringify(extension),
            ip_address: item.ip,
            network_id: this.$route.params.id,
            name: item.ip,
            resource_type: this.$route.query.type
          })
        })
        this.$store.dispatch(STORE_CONST.CLUSTER.POST_BATCH_RESOURCE, params).then(res => {
          this.queryScan.importLoading = false
          this.$emit('callback')
          this.$notify({
            type: 'success',
            message: this.$gettext('Import success')
          })
          this.onCloseForm()
        }).catch((err) => {
          this.queryScan.importLoading = false
          if (err.code === 'ResourceExceeded') {
            this.$notify({
              type: 'error',
              message: this.$gettext('ResourceExceeded.')
            })
          }
        })
      },
      // 关闭扫描导入
      onCloseForm () {
        clearTimeout(this.queryTimeout)
        this.connects = null
        this.$emit('onClosePanel')
      },
      tableRowClassName (row, index) {
        if (index % 2 === 0) {
          return 'info-row'
        }
        return ''
      }
    },
    watch: {
      scanForm: {
        handler: function (newVal, oldVal) {
          this.$refs['scanForm'].validate((valid) => {
            this.queryScan.isCanScan = valid
          })
        },
        deep: true
      },
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
          this.agentVersion = Utilty.Utils.getAgentVersion(this.connects.agent.version)
          console.log('agent', Utilty.Utils.getAgentVersion(this.connects.agent.version))
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  .scan-process {
    position: relative;
    height: 32px;
    .process {
      position: absolute;
      top: 6px;
      left: 0;
      display: inline-block;
      width: 70%;
    }
    .scan-btn {
      display: inline-block;
      width: 100%;
      line-height: 36px;
      position: absolute;
      top: 0;
      right: 0;
      .hide_duplicate_switch {
        display: inline-block;
      }
      .scan_again {
        float: right;
      }
    }
  }

  .scan-table {
    margin-top: 30px;
  }
</style>




// WEBPACK FOOTER //
// cluster-scan-import.vue?393a7760